import { Directive, TemplateRef } from '@angular/core';

@Directive({
	selector: 'ng-template[aeToggleButtonOn]',
})
export class ToggleButtonOnDirective {
	constructor(public template: TemplateRef<any>) {}
}
